import { connect } from "react-redux";
import { FAMILY_MEMBER, STAFF_USER } from "Constants/stringConstants";
import { getUserEntityType } from "modules/CommonSelectors";
import { getIsAdminByRole } from "lib/staffPermissionUtils";

// StudentPermission and AdminPermission are commented out because they are not used in the codebase.
const mapStateToProps = state => {
  return {
    userType: getUserEntityType(state),
    isAdmin: getIsAdminByRole(),
  };
};

const StaffPermissionComponent = ({
  children,
  userType,
  isCustomConditionSatisfied = true,
}) => {
  return userType === STAFF_USER && isCustomConditionSatisfied && children
    ? children
    : null;
};

export const StaffPermission = connect(
  mapStateToProps,
  null
)(StaffPermissionComponent);

// const StudentPermissionComponent = ({
//   children,
//   userType,
//   isCustomConditionSatisfied = true,
// }) => {
//   return userType === STUDENT_USER && isCustomConditionSatisfied && children
//     ? children
//     : null;
// };

// export const StudentPermission = connect(
//   mapStateToProps,
//   null
// )(StudentPermissionComponent);

const ParentPermissionComponent = ({
  children,
  userType,
  isCustomConditionSatisfied = true,
}) => {
  return userType === FAMILY_MEMBER && isCustomConditionSatisfied && children
    ? children
    : null;
};

export const ParentPermission = connect(
  mapStateToProps,
  null
)(ParentPermissionComponent);

// const AdminPermissionComponent = ({
//   children,
//   userType,
//   isCustomConditionSatisfied = true,
//   isAdmin,
// }) => {
//   return userType === STAFF_USER &&
//     isAdmin &&
//     isCustomConditionSatisfied &&
//     children
//     ? children
//     : null;
// };

// export const AdminPermission = connect(
//   mapStateToProps,
//   null
// )(AdminPermissionComponent);
